import { render, staticRenderFns } from "./RowSections.vue?vue&type=template&id=4b088d16&scoped=true&"
import script from "./RowSections.vue?vue&type=script&lang=js&"
export * from "./RowSections.vue?vue&type=script&lang=js&"
import style0 from "./RowSections.vue?vue&type=style&index=0&id=4b088d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b088d16",
  null
  
)

export default component.exports